import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SharedForm from "../../../../../widgets/SharedForm";
import { fnSave } from "@shared/api/restApi";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;

  [key: string]: any;
}

const SN_MAS_ORG_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  const [columns, setColums] = useState<any[]>([]);
  const [sharedForm, setSharedForm] = useState<any[]>([]);
  const [dataSource1, setDataSource1] = useState<any>([]);
  const SharedFormref1 = useRef<any>();

  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const nextYearSameDate = new Date(today);
  nextYearSameDate.setFullYear(today.getFullYear() + 1);
  nextYearSameDate.setDate(nextYearSameDate.getDate() - 1);
  const formatted = `${nextYearSameDate.getFullYear()}${(
    nextYearSameDate.getMonth() + 1
  )
    .toString()
    .padStart(
      2,
      "0"
    )}${nextYearSameDate.getDate().toString().padStart(2, "0")}`;

  //#region grid 길이 관련
  const cd_menu = Menuprops.cd_menu || "SN_MAS_ORG_REG_001";
  const defaultSize = { panel1: "29.5%", panel2: "70%" };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize);
  //#endregion

  const gridref1 = useRef<any>(null);
  const { userInfo } = global();
  const [focusedRowData, setFocusedRowData] = useState<any>();

  useImperativeHandle(ref, () => ({
    onSave,
  }));

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({
          menuInfo: Menuprops,
          etcInfo: {},
        });
        setSharedForm(rtn.form.freeform1);
        setColums(rtn.grid.grid1);
      } catch (error) {}
    };
    fetchform();
    onSearch();
  }, []);

  const onSearch = async () => {
    try {
      const params = {
        id: "sn_mas_org_reg_001_01",
        params: {
          cd_firm: userInfo.cd_firm,
        },
      };

      setFocusedRowData(null);
      const result: any = await fnGetDataSet(params);
      const data = result[0];
      if (data && data.length > 0) {
        setDataSource1(data);
        gridref1.current.resetUpdate();
      } else {
        onInsert();
      }
    } catch (error) {}
  };

  const onInsert = () => {
    const result = gridref1.current.addRow();
  };

  const onBeforeAddRow = (): boolean | Record<string, any> => {
    try {
      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        dt_start: todayform,
        dt_end: formatted,
      };

      return updatedRow;
    } catch (error: any) {
      return false; // 추가 취소
    }
  };

  const onSave = async () => {
    let masFirmChanges;
    try {
      const requiredValuesCheckH = gridref1.current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }

      masFirmChanges = gridref1.current.getChange();
      if (masFirmChanges.modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      const insertList = masFirmChanges.insert;
      for (const i of insertList) {
        if (!i.no_biz) {
          await showDialog("alter", "사업자번호은(는) 필수값입니다.");
          return;
        }
      }

      const updateList = masFirmChanges.update;
      for (const u of updateList) {
        if (!u.no_biz) {
          await showDialog("alter", "사업자번호은(는) 필수값입니다.");
          return;
        }
      }

      const SaveData = {
        mas_firm: masFirmChanges,
      };
      await fnSave("SN_MAS_ORG_REG_001", SaveData);
      gridref1.current.resetUpdate();
    } catch (error) {}
  };

  const onFocusedRowChanged = useCallback(
    (focusedRowData: any) => {
      setFocusedRowData(focusedRowData);
    },
    [focusedRowData]
  );

  const onValueChaged = async (data: any, param: string, formData: any) => {
    if (param === "no_post") {
      return { dc_address1: data.dc_address };
    }
    if (param === "no_post_boss") {
      return { dc_address_boss1: data.dc_address };
    }
  };

  const onRowDataReady = () => {
    gridref1.current.selectAndFocusRow(0);
  };

  return (
    <div className="w-full flex h-full min-h-0 space-x-1.5">
      <SnResizable
        direction={"width"}
        seq={1}
        cd_menu={cd_menu}
        defaultSize={defaultSize}
        size={sizes.panel1}
        onResizeStop={onResizeStop}
        enable={{ right: true }}
        minWidth={130}
        minHeight={130}
      >
        <div className="h-full">
          <SnGrid
            ref={gridref1}
            rowData={dataSource1}
            columnConfig={columns}
            etcProps={{
              isEditable: false,
              rowSelection: "single",
              title: "회사정보",
            }}
            events={{
              onFocusedRowChanged,
              onRowDataReady: onRowDataReady,
              onBeforeAddRow,
            }}
            // resizeController={{
            //   defaultSize: defaultSize,
            //   onResizeStop: onResizeStop,
            // }}
          />
        </div>
      </SnResizable>
      <SnResizable
        direction={"width"}
        seq={2}
        cd_menu={cd_menu}
        defaultSize={defaultSize}
        size={sizes.panel2}
        onResizeStop={onResizeStop}
        enable={{ right: true }}
        minWidth={130}
        minHeight={130}
      >
        <SharedForm
          ref={SharedFormref1}
          data={focusedRowData}
          controls={sharedForm}
          gridref={gridref1}
          title="상세내용"
          
          onValueChaged={onValueChaged}
        ></SharedForm>
      </SnResizable>
    </div>
  );
});

export default SN_MAS_ORG_REG_001;
